// AUTH actions
import axios from 'axios';
import types from '../../types';

/* eslint-disable */
export default {
  [types.SHOW_APP_VIEWS]: ({ commit }, payload) => {
    commit('SHOW_APP_VIEWS', payload);
  },
  [types.LOGIN]: async ({ commit }, payload) => {
    try {
      return await axios.post('/authenticate/login', {...payload}).then((res) => {
        return res.data.data;
      })
    } catch (e) {
      commit('SHOW_ERROR', e.response.data.message);
      throw new Error(e);
    }
  },
  [types.FORGOT_PASSWORD]: async ({ commit }, payload) => {
    try {
      let response = await axios.post('/authenticate/forgot-password', {...payload});
      return response.data.data;
    } catch (e) {
      commit('SHOW_ERROR', e.response.data.message);
      throw new Error(e);
    }
  },
  [types.RESET_PASSWORD]: async ({ commit }, payload) => {
    try {
      let response = await axios.post('/authenticate/reset-password', {...payload});
      return response.data.data;
    } catch (e) {
      commit('SHOW_ERROR', e.response.data.message);
      throw new Error(e);
    }
  },
  [types.LOGOUT]: ({ commit }) => {
    commit('LOGOUT');
  },
  [types.GET_PROFILE]: async ({ commit }) => {
    try {
      return await axios.get('/profile').then((res) => {
        return res.data.data;
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  [types.TEST_TOKEN]: async ({ commit }) => {
    try {
      return await axios.get('/profile').then((res) => {
        return 200;
      });
    } catch (e) {
      return e.response.status;
    }
  },
  [types.REFRESH_TOKEN]: async ({ commit, dispatch }, payload) => {
    try {
      if (!payload || !axios.defaults.headers.common.Authorization) return;
      localStorage.setItem('refreshTokenInProcess', '1')
      //If it needed, add client timezone in request (if client/server time is not matched)
      return await axios.post('/refresh-token', {token: payload}).then((resp) => {
        const payload = resp.data.data.token;
        dispatch('STORE_TOKEN', payload);
      });
    } catch (e) {
      console.log(e.message)
      commit('LOGOUT');
      return e.response.status;
    }
  },
  [types.LOGIN_USER_FLAG]: ({ commit }, payload) => {
    commit('LOGIN_USER_FLAG', payload);
  },
  [types.STORE_USER]: ({ commit }, payload) => {
    localStorage.setItem('lang', payload.language);
    commit('STORE_USER', payload);
  },
  [types.STORE_TOKEN]: ({ commit }, payload) => {
    commit('STORE_TOKEN', payload);
    localStorage.setItem('token', payload);
    axios.defaults.headers.common = {
      Authorization: `Bearer ${payload}`,
    };
    localStorage.setItem('refreshTokenInProcess', '0');
  },
  [types.GET_SUBACCOUNTS]: async ({ commit }) => {
    try {
      return await axios.get('/subaccount').then((res) => {
        commit('STORE_SUBACCOUNTS', res.data.data);
        return res.data.data;
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  [types.STORE_ACTIVE_SUBACCOUNT]: ({ commit }, payload) => {
    commit('STORE_ACTIVE_SUBACCOUNT', payload);
  },
};
